/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * List of calendar block entries to create
 */
export type CalendarBlockEntryDto = {
    /**
     * Date in ISO8601 format (yyyy-MM-dd)
     */
    date?: string;
    /**
     * Start time in ISO8601 format (HH:mm)
     */
    startTime?: string;
    /**
     * End time in ISO8601 format (HH:mm)
     */
    endTime?: string;
    /**
     * Reason for blocking calendar
     */
    reason?: CalendarBlockEntryDto.reason;
};
export namespace CalendarBlockEntryDto {
    /**
     * Reason for blocking calendar
     */
    export enum reason {
        TRAINING_UNIT = 'TRAINING_UNIT',
        PRESEASON_GAME = 'PRESEASON_GAME',
        PRESEASON_UNAVAILABLE = 'PRESEASON_UNAVAILABLE',
    }
}

